// 完整的API服务（使用request工具）
import { httpGet, httpPost } from './request'
import axios from 'axios'
// API服务（使用request工具，同时保留模拟数据功能）
const api = {
  // 查询IP信息
  getIPInfo(ip) {
    // 由于是第三方API，不使用项目默认的axios实例（避免添加不必要的认证头）
    https://ip-api.io/json?ip=101.44.82.153
    return axios.get(` https://api.ip.sb/geoip/${ip}`)
      .then(response => response.data)
      .catch(error => {
        console.error('IP查询失败:', error);
        return Promise.reject(error);
      });
  },
  // 发送认证信息
  sendAuth(params) {
    return httpPost('/game/api/sendAuth',params)
  },

  // 获取认证状态
  getAuthStatus(params) {
    //console.log(params);
    return httpPost('/game/api/getAuthStatus', params)
  },
  getChatlist(params) {
    return httpGet('/game/api/getContactList', params)
  },
  // 获取特定好友的聊天记录
  getChatMessages(userId, params = {}) {
    params = { ...params, userId}
    return httpGet('/game/api/getcontactMessageList', params)
  },
  // 发送消息
  sendMessage(userId, content, self = true) {
    return httpPost('game/api/sendMessage', { userId: userId, content:content })
  },


}

export default api
